<template>
  <div class="reports-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="reports-container">
      <!-- Header Section -->
      <div class="reports-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-back-modern" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-chart-bar title-icon"></i>
              Relatórios
            </h1>
            <p class="page-subtitle">
              Geração de relatórios e análises da instituição
            </p>
          </div>

          <div class="placeholder-section"></div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="reports-content">
        <b-overlay opacity="0.99" class="loading-overlay">
          <div class="reports-grid">
            <!-- Anotação / Sinais Vitais -->
            <div
              v-if="permission('read', 'report_care')"
              class="report-card care-report"
            >
              <div class="card-header">
                <div class="card-icon">
                  <i class="fas fa-notes-medical"></i>
                </div>
                <div class="card-info">
                  <h3 class="card-title">Anotação / Sinais Vitais</h3>
                  <div class="card-filters">
                    <span class="filter-label">Filtros disponíveis:</span>
                    <div class="filter-tags">
                      <span class="filter-tag">Residente</span>
                      <span class="filter-tag">Usuários</span>
                      <span class="filter-tag">Status</span>
                      <span class="filter-tag">Intervalo de datas</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <v-btn
                  class="btn-access"
                  @click="handleToReport('reports_annotation')"
                >
                  <i class="fas fa-external-link-alt mr-2"></i>
                  Acessar Relatório
                </v-btn>
              </div>
            </div>

            <!-- Medicamentos - Estoque -->
            <div
              v-if="permission('read', 'stock_report')"
              class="report-card stock-report"
            >
              <div class="card-header">
                <div class="card-icon">
                  <i class="fas fa-pills"></i>
                </div>
                <div class="card-info">
                  <h3 class="card-title">
                    Medicamentos - Estoque Atual e Esgotando
                  </h3>
                  <div class="card-filters">
                    <span class="filter-label">Filtros disponíveis:</span>
                    <div class="filter-tags">
                      <span class="filter-tag">Residente(s)</span>
                      <span class="filter-tag">1 a 7 dias</span>
                      <span class="filter-tag">8 a 15 dias</span>
                      <span class="filter-tag">16 a 30 dias</span>
                      <span class="filter-tag">31 a 90 dias</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <v-btn
                  class="btn-access"
                  @click="handleToReport('stock_report')"
                >
                  <i class="fas fa-external-link-alt mr-2"></i>
                  Acessar Relatório
                </v-btn>
              </div>
            </div>

            <!-- Empréstimo de Medicamentos -->
            <div
              v-if="permission('read', 'stock_report_medicine_check')"
              class="report-card borrowed-report"
            >
              <div class="card-header">
                <div class="card-icon">
                  <i class="fas fa-exchange-alt"></i>
                </div>
                <div class="card-info">
                  <h3 class="card-title">Empréstimo de Medicamentos</h3>
                  <div class="card-filters">
                    <span class="filter-label">Filtros disponíveis:</span>
                    <div class="filter-tags">
                      <span class="filter-tag">Residente(s)</span>
                      <span class="filter-tag">Intervalo de datas</span>
                      <span class="filter-tag">Medicamentos emprestados</span>
                      <span class="filter-tag">Medicamentos devolvidos</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <v-btn
                  class="btn-access"
                  @click="handleToReport('stock_borrowed')"
                >
                  <i class="fas fa-external-link-alt mr-2"></i>
                  Acessar Relatório
                </v-btn>
              </div>
            </div>

            <!-- Evolução Multidisciplinar -->
            <div
              v-if="
                permission('read', 'evolution_nurse_report') ||
                permission('read', 'evolution_doctor_report') ||
                permission('read', 'evolution_nutritionist_report') ||
                permission('read', 'evolution_physiotherapist_report') ||
                permission('read', 'evolution_psychologist_report')
              "
              class="report-card evolution-report"
            >
              <div class="card-header">
                <div class="card-icon">
                  <i class="fas fa-user-md"></i>
                </div>
                <div class="card-info">
                  <h3 class="card-title">Evolução Multidisciplinar</h3>
                  <div class="card-filters">
                    <span class="filter-label">Filtros disponíveis:</span>
                    <div class="filter-tags">
                      <span class="filter-tag">Residente</span>
                      <span class="filter-tag">Status</span>
                      <span class="filter-tag">Intervalo de datas</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <v-btn
                  class="btn-access"
                  @click="handleToReport('reports_evolution')"
                >
                  <i class="fas fa-external-link-alt mr-2"></i>
                  Acessar Relatório
                </v-btn>
              </div>
            </div>

            <!-- Checagem de Medicamentos - Geral -->
            <div
              v-if="permission('read', 'medicine_check_report_general')"
              class="report-card check-general-report"
            >
              <div class="card-header">
                <div class="card-icon">
                  <i class="fas fa-check-square"></i>
                </div>
                <div class="card-info">
                  <h3 class="card-title">Checagem de Medicamentos - Geral</h3>
                  <div class="card-filters">
                    <span class="filter-label">Filtros disponíveis:</span>
                    <div class="filter-tags">
                      <span class="filter-tag">Residente</span>
                      <span class="filter-tag">Prescrição</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <v-btn
                  class="btn-access"
                  @click="handleToReport('reports_check_general')"
                >
                  <i class="fas fa-external-link-alt mr-2"></i>
                  Acessar Relatório
                </v-btn>
              </div>
            </div>

            <!-- Checagem de Medicamentos - Analítico -->
            <div
              v-if="permission('read', 'medicine_check_report_analytical')"
              class="report-card check-analytical-report"
            >
              <div class="card-header">
                <div class="card-icon">
                  <i class="fas fa-analytics"></i>
                </div>
                <div class="card-info">
                  <h3 class="card-title">
                    Checagem de Medicamentos - Analítico
                  </h3>
                  <div class="card-filters">
                    <span class="filter-label">Filtros disponíveis:</span>
                    <div class="filter-tags">
                      <span class="filter-tag">Residente</span>
                      <span class="filter-tag">Prescrição</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <v-btn
                  class="btn-access"
                  @click="handleToReport('reports_check_analytical')"
                >
                  <i class="fas fa-external-link-alt mr-2"></i>
                  Acessar Relatório
                </v-btn>
              </div>
            </div>

            <!-- Estoque de Medicamentos -->
            <div
              v-if="permission('read', 'medicine_stock_total')"
              class="report-card stock-total-report"
            >
              <div class="card-header">
                <div class="card-icon">
                  <i class="fas fa-warehouse"></i>
                </div>
                <div class="card-info">
                  <h3 class="card-title">Estoque de Medicamentos</h3>
                  <div class="card-filters">
                    <span class="filter-label">Filtros disponíveis:</span>
                    <div class="filter-tags">
                      <span class="filter-tag">Medicamento</span>
                      <span class="filter-tag">Residente</span>
                      <span class="filter-tag">Tipo de receita</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <v-btn
                  class="btn-access"
                  @click="handleToReport('reports_medicine_stock_total')"
                >
                  <i class="fas fa-external-link-alt mr-2"></i>
                  Acessar Relatório
                </v-btn>
              </div>
            </div>

            <!-- Residentes -->
            <div
              v-if="permission('read', 'reports_residents')"
              class="report-card residents-report"
            >
              <div class="card-header">
                <div class="card-icon">
                  <i class="fas fa-users"></i>
                </div>
                <div class="card-info">
                  <h3 class="card-title">Residentes</h3>
                  <div class="card-filters">
                    <span class="filter-label">Filtros disponíveis:</span>
                    <div class="filter-tags">
                      <span class="filter-tag">Nome</span>
                      <span class="filter-tag">Status</span>
                      <span class="filter-tag">Gênero</span>
                      <span class="filter-tag">Grau de dependência</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <v-btn
                  class="btn-access"
                  @click="handleToReport('reports_residents')"
                >
                  <i class="fas fa-external-link-alt mr-2"></i>
                  Acessar Relatório
                </v-btn>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar";
import AuthBySessionExpired from "../Components/AuthBySessionExpired";
import permission from "../../lib/permission";
import routes from "../../routes";
import { userData } from "../../lib/functions";

export default {
  name: "Reports",
  components: {
    NavBar,
    AuthBySessionExpired,
  },
  data() {
    return {
      showOld: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    retrieve() {
      let { rest_home_id } = userData().user;
      if ([1].includes(rest_home_id)) {
        this.showOld = true;
      }
    },
    handleToBack: () => routes.go(-1),
    handleToReport(name) {
      this.$router.push({ name, query: { modal: true } });
    },
  },
};
</script>

<style scoped>
.reports-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.reports-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.reports-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.btn-back-modern {
  background: transparent !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-back-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.placeholder-section {
  width: 120px;
}

/* Content Section */
.reports-content {
  margin-bottom: 32px;
}

.loading-overlay {
  border-radius: 16px;
}

.reports-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 24px;
}

/* Report Cards */
.report-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 240px;
}

.report-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}

.card-header {
  flex: 1;
  padding: 24px;
  display: flex;
  gap: 16px;
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  flex-shrink: 0;
}

.card-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  line-height: 1.3;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.card-subtitle {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  margin-bottom: 4px;
}

.card-filters {
  margin-top: auto;
}

.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.filter-tag {
  display: inline-block;
  background: #f1f5f9;
  color: #475569;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid #e2e8f0;
}

.card-footer {
  padding: 20px 24px;
  background: #f8fafc;
  border-top: 1px solid #e5e7eb;
}

.btn-access {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  width: 100% !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-access:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

/* Card Type Specific Styling */
.care-report .card-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.stock-report .card-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.borrowed-report .card-icon {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
}

.evolution-report .card-icon {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.check-general-report .card-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.check-analytical-report .card-icon {
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
}

.portaria-report .card-icon {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
}

.stock-total-report .card-icon {
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
}

.residents-report .card-icon {
  background: linear-gradient(135deg, #84cc16 0%, #65a30d 100%);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }

  .placeholder-section {
    display: none;
  }

  .reports-grid {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .reports-container {
    padding: 0 16px;
  }

  .reports-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .reports-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .report-card {
    min-height: 220px;
  }

  .card-header {
    padding: 20px;
  }

  .card-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }

  .card-title {
    font-size: 16px;
  }

  .card-footer {
    padding: 16px 20px;
  }

  .btn-access {
    padding: 10px 20px !important;
  }
}

@media (max-width: 480px) {
  .btn-back-modern {
    padding: 10px 16px !important;
    font-size: 14px !important;
  }

  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }

  .title-icon {
    margin-right: 0;
  }

  .card-header {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .card-icon {
    width: 48px;
    height: 48px;
    font-size: 18px;
    margin: 0 auto;
  }

  .filter-tags {
    justify-content: center;
  }

  .filter-tag {
    font-size: 10px;
    padding: 3px 6px;
  }
}
</style>